import {IVehicleRegistration} from '../../interfaces/interfaces';
import {ReminderItem} from './ReminderItem';
import * as moment from 'moment';
import {Injectable} from '@angular/core';

@Injectable()
export class RegoReminderItem  extends ReminderItem {
  accessibilityPrefix = 'A reminder for your vehicle registration which';
  titlePrefix = {
    EXPIRED : 'Overdue registration for',
    EXPIRING : 'Expiring registration for'
  };

  iconMap = {
    'EXPIRING' : '/assets/reminder/reminder_certificate_orange.jpg',
    'EXPIRED' : '/assets/reminder/reminder_alert_icon.jpg'
  };

  descriptionMap = {
    'EXPIRING' : 'Expires',
    'EXPIRED' : 'Expired'
  };

  constructor(regoDetail: IVehicleRegistration) {
    super();
    this.actionLink = 'https://www.service.transport.qld.gov.au/renewregistration';
    this.analyticsName = 'Rego Vehicle';
    this.expiryDate = moment(regoDetail.expiryDate).toDate();
    this.status = regoDetail.status;
    this.description = this.descriptionMap[this.status] + ' ' + ReminderItem.formatDate(this.expiryDate);
    this.icon = this.iconMap[this.status];
    this.accessibility = this.accessibilityPrefix + ' ' + this.descriptionMap[this.status].toLowerCase() + ' ' + ReminderItem.formatDate(this.expiryDate);
    this.title = this.titlePrefix[this.status] + ' ' + regoDetail.make + ' ' + regoDetail.model + ' ' + regoDetail.plateNo;
    this.dismissId = 'rego_' + regoDetail.plateNo + '_' + this.status + '_' + ReminderItem.formatDateForId(this.expiryDate);
  }
}



// WEBPACK FOOTER //
// ./app/reminder/dataObject/RegoReminderItem.ts